import { render, staticRenderFns } from "./DepartmentDialog.vue?vue&type=template&id=0e2bc1d8"
import script from "./DepartmentDialog.vue?vue&type=script&lang=ts"
export * from "./DepartmentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports